<div class="measurement-log-list">
    <div class="measurement--case-summary" *ngIf="case">
        Sag nr. {{case.id}} ({{case.customer?.fullName}}) hyh
    </div>
    <!-- <div *ngIf="case" class="category-list" [class.details]="!_router.isActive(_router.createUrlTree(['/measurement', case.id]), true)"> -->
    <div *ngIf="caseid" class="category-list">
        <div class="categories">
            <ul class="measurement-log-list" *ngIf="case">
                <li *ngFor="let m of case.measurementLogs">
                    <a *ngIf="!editMode[m.id]; else editField" [routerLink]="['/measurement', caseid, m.id]" routerLinkActive="active">
                        <span class="log-name">{{ m.name }}</span>
                    </a>
                    
                    <ng-template class="log-name" #editField>
                        <input type="text" [(ngModel)]="m.name" (click)="$event.stopPropagation()" />
                    </ng-template>
                
                    <span class="log-icons">
                        <i *ngIf="editMode[m.id]" (click)="ret(m.id)" title="Annuler" class="fa fa-times fa-lg"></i>
                        <i *ngIf="editMode[m.id]" (click)="save(m)" title="Gem" class="fa fa-save fa-lg"></i>
                        <i *ngIf="!editMode[m.id] && m.transactions.length === 0" (click)="removeEntry(m.id)" title="Slet" class="fa fa-trash fa-lg"></i>
                        <i *ngIf="!editMode[m.id]" (click)="ret(m.id)" title="Ret" class="fa fa-edit fa-lg"></i>

                    </span>
                    <!-- <span class="log-icons">
                        <i *ngIf="editMode[m.id]" (click)="ret(m.id)" title="Annuler" class="fa fa-times fa-lg"></i>
                        <i *ngIf="editMode[m.id]" (click)="save(m)" title="Gem" class="fa fa-save fa-lg"></i>
                        <i *ngIf="!editMode[m.id] && m.transactions.length === 0" (click)="removeEntry(m.id)" title="Slet" class="fa fa-trash fa-lg"></i>
                        <i *ngIf="!editMode[m.id]" (click)="ret(m.id)" title="Ret" class="fa fa-edit fa-lg"></i>
                    </span> -->
                </li>
            </ul>
            <div class="create-block">
                <h2>Tilføj journal</h2>
                <form (ngSubmit)="f.form.valid && onSubmitCreate()" #f="ngForm" class="create">
                    <div class="field-group">
                        <label for="room">Rum</label>
                        <div class="input-group">
                            <input type="text" name="room" id="room" [(ngModel)]="newLog.name" required />
                            <button type="submit">Opret</button>
                        </div>
                    </div>
                </form>                             
            </div>
        </div>
        <div class="list-container">
            <measuring-point></measuring-point>
        </div>
    </div>
</div>